"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.Breadcrumbs = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _Breadcrumb = _interopRequireDefault(require("../../components/Breadcrumb"));

var _Icon = _interopRequireDefault(require("../../components/Icon"));

var Breadcrumbs = function Breadcrumbs(props) {
  return /*#__PURE__*/React.createElement(_Breadcrumb["default"], (0, _extends2["default"])({
    divider: props.sections ? /*#__PURE__*/React.createElement(_Icon["default"], {
      name: "chevron-right"
    }) : undefined
  }, props));
};

exports.Breadcrumbs = Breadcrumbs;
var _default = Breadcrumbs;
exports["default"] = _default;